import React from "react";

export interface WidgetListProps {
  content: unknown;
}

function renderItem(item: unknown): React.ReactNode {
  if (item === null || item === undefined) return "—";
  if (typeof item !== "object") return String(item);
  const entries = Object.entries(item as Record<string, unknown>);
  return (
    <div className="flex flex-col gap-0.5">
      {entries.map(([k, v]) => (
        <span key={k}>
          <span className="font-medium text-[#6B7280]">{k}: </span>
          <span className="text-[#3A3F51]">
            {typeof v === "boolean" ? (v ? "✓" : "✗") : String(v ?? "")}
          </span>
        </span>
      ))}
    </div>
  );
}

export function WidgetList({ content }: WidgetListProps): React.JSX.Element {
  const items = Array.isArray(content) ? content : content != null ? [content] : [];

  if (items.length === 0) {
    return <></>;
  }

  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm my-1 overflow-hidden">
      <ul className="divide-y divide-gray-100 mb-0">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2 px-3 py-2 text-xs">
            <span className="mt-0.5 flex-shrink-0 w-4 h-4 rounded-full bg-[#EEF2FF] text-[#4F46E5] text-[10px] font-semibold flex items-center justify-center">
              {i + 1}
            </span>
            <span className="text-[#3A3F51] break-words min-w-0 flex-1">{renderItem(item)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
